import { createGridMesh } from "../../assetBuilders/grid";
import { materialForColor } from "../../assetBuilders/materials";
import { BabylonState } from "../../state";

/**
 * Generates the grid mesh based on the current grid spec and camera viewing range.
 */
export function reloadStaleGrid(state: BabylonState) {
  const grid = state.sceneConfig.grid;
  if (grid?.load?.state !== "stale") {
    return;
  }
  grid.mesh?.dispose();
  grid.material?.dispose();
  // TODO: if the mesh rebuild slows down the main thread, split it up into units of work here.

  // Recompute the grid size.
  // The grid should extend all the way to the draw distance limit, determined by the fog rn.
  // Formulas for fog transparency available here:
  // https://learn.microsoft.com/en-us/previous-versions/windows/desktop/bb324452(v=vs.85)
  // Anything further than the distance where the fog becomes nearly opaque
  // is effectively not visible.
  const NEARLY_OPAQUE = 0.01;
  // Fog transparency of 0 means only fog is visible, which happens at infinite distance.
  // Therefore, solve for fog transparency close to zero to set a cutoff where drawing things
  // (like the infinite grid) doesn't make sense anymore
  const fogDensity = state.context.scene.fogDensity;
  const maxDrawDistance = Math.log(1 / NEARLY_OPAQUE) / fogDensity;
  const scale = grid.spec.scale;
  // Don't make a grid if the scale is not set right.
  if (scale === undefined || !Number.isFinite(scale) || scale <= 0) {
    grid.load.state = "loaded";
    return;
  }
  const mesh = createGridMesh(
    "sceneConfig.grid.mesh",
    scale,
    // The grid runs from max draw distance on one side to max distance on the
    // opposite side of the camera.
    // No need to continue the grid beyond the maximum draw distance.
    // Also, set a hard limit of 2k lines.
    Math.min(maxDrawDistance * 2, 2e3 * scale),
    state.context.scene,
  );
  const material = materialForColor(
    "sceneConfig.grid.material",
    grid.spec.color,
    state.context.scene,
  );
  mesh.material = material;
  // Flag the grid for reconstruction.

  grid.material = material;
  grid.mesh = mesh;
  grid.load.state = "loaded";
}
